<template>
  <div class="page__main--824">
    <h1 class="m-b-m">Welcome to Feelgood Design System</h1>
    <p class="m-b-xxl lead">Everything you’ll eventually need to build great and accessible solutions for Feelgood.</p>
    <section class="welcome">
      <fds-content-block variant="primary" class="m-b-none">
        <div slot="header">How to get started</div>
        <p>Get started by having a look at the basics like <router-link to="/colors">colors</router-link>, <router-link to="/icons">icons</router-link>, <router-link to="/spacing">spacing</router-link>, and <router-link to="/typography">typography</router-link>.</p>
      </fds-content-block>
      <fds-content-block variant="primary" class="m-b-none">
        <div slot="header">Components in Storybook</div>
        <p>For easier maintenance, we've moved our components to <a :href="storybookPath">storybook.feelgood.se</a>.</p>
      </fds-content-block>
      <fds-content-block variant="primary" class="m-b-none">
        <div slot="header">Getting codebase access</div>
        <p>Codebase access is only granted to employees or consultants at Feelgood. Looking for <a href="https://feelgood.se/karriar/digital-utveckling" target="_blank">employment</a>?</p>
      </fds-content-block>
      <fds-content-block variant="primary" class="m-b-none">
        <div slot="header">Missing something?</div>
        <p>Please contact us through <a href="mailto: design@feelgood.se">design@feelgood.se</a> on how we can improve our design system.</p>
      </fds-content-block>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    storybookPath () {
      const path = window.location
      switch (path.hostname) {
        case 'localhost':
        case 'dev-kund.feelgood.se':
          return 'http://dev-kund.feelgood.se:8402/'
        case 'preprod-design.feelgood.se':
          return 'https://preprod-storybook.digital.feelgood.se/'
        case 'design.feelgood.se':
          return 'https://storybook.feelgood.se/'
        default:
          return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page__main {
  max-width: 824px;
}
.welcome {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: set-gutter('xl');
  @media all and (min-width: set-bp('s')) {
    grid-template-columns: 1fr 1fr;
  }
  &__components__sticker {
    min-width: 72px;
  }
}
</style>
